import PropTypes from 'prop-types';

const Column = () => {
  return null;
};

Column.propTypes = {
  dataKey: PropTypes.string.isRequired,
  headerOverride: PropTypes.element,
  label: PropTypes.string,
  format: PropTypes.object,
  headerIcon: PropTypes.string,
  totalValue: PropTypes.node,
  sortable: PropTypes.bool,
  cellRender: PropTypes.func,
  labelRender: PropTypes.func,
  className: PropTypes.string,
  justifyContent: PropTypes.oneOf(['left', 'center', 'right']),
  width: PropTypes.number,
  flexWidth: PropTypes.bool,
  tooltip: PropTypes.func,
  isShowing: PropTypes.bool,
};

Column.defaultProps = {
  headerOverride: null,
  label: '',
  headerIcon: null,
  format: null,
  sortable: false,
  cellRender: null,
  labelRender: null,
  tooltip: null,
  className: null,
  minWidth: null,
  width: 125,
  flexWidth: false,
  isShowing: true,
};

export default Column;
